<template>
  <div class="LKRoadmapsExpertsCriteria">
    <v-row class="LKRoadmapsExpertsCriteria__criteria">
      <v-col cols="6">
        <div>{{ criteria.display_name }}</div>
      </v-col>
      <v-col cols="2">
        <div>{{ sum }}</div>
      </v-col>
    </v-row>

    <v-card
      v-for="parameter in criteria.parameters"
      :key="parameter.id"
      class="LKRoadmapsExpertsCriteria__parameter"
    >
      <v-row>
        <v-col cols="6">
          <div class="LKRoadmapsExpertsCriteria__parameter__name">
            {{ parameter.display_name }}
          </div>
        </v-col>
        <v-col cols="2">
          <v-autocomplete
            v-model="parameter.value"
            v-validate="{ required: true }"
            :name="`param-${parameter.id}`"
            :data-vv-as="parameter.display_name"
            :error="$errors.has(`param-${parameter.id}`)"
            :error-messages="$errors.first(`param-${parameter.id}`)"
            :items="parameter.variants"
            :readonly="readonly"
            label="Варианты"
            hide-details="auto"
            outlined
            dense
          />
        </v-col>
        <v-col cols="4">
          <BTextField
            v-model="parameter.comment"
            :max-counter="1000"
            :readonly="readonly"
            :rows="3"
            validate="required"
            label="Комментарий"
          />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import BTextField from '@/components/forms/BTextarea.vue'

export default {
  inject: ['$validator'],
  components: {
    BTextField,
  },
  props: {
    criteria: {
      type: Object,
      required: true,
    },
    readonly: Boolean,
  },
  computed: {
    sum() {
      return this.criteria.parameters.reduce(
        (acc, cur) => acc + (cur.value || 0),
        0,
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.LKRoadmapsExpertsCriteria {
  margin: 2rem 0;

  &__criteria {
    margin: 12px 0;
    font-size: 1.2rem;
    color: $webflow-color-white;
    background-color: $webflow-color-green;
  }

  &__parameter {
    padding: 0 2rem;
    margin: 2rem 0;

    &__name {
      display: flex;
      align-items: center;
    }

    &:last-child {
      margin-bottom: 12px;
    }
  }
}
</style>
